import { Skeleton } from '@mui/material';

export const CustomerInvoicesSkeleton = () => {
  return (
    <Skeleton
      variant="rectangular"
      sx={{ borderRadius: '10px', height: '700px', marginTop: '16px', position: 'relative' }}
    />
  );
};
